
import React, {useContext, useEffect, useState} from 'react';

import './planning.css';
import PlannerContent from "./PlannerContent";
import PlannerResponsive from "./PlannerResponsive";
import {PAContext} from "../../../Services/PAContext";



function Planner(props) {

    const { dataArray } = useContext(PAContext);
    const { isMobileView } = dataArray;

    const [lookingAt, setLookingAt] = useState('Planner');
    const [zoomInOn, setZoomInOn] = useState({});

    useEffect(() => {
        console.log("props.showConciergeServiceWindow : ", props.showConciergeServiceWindow);
    }, [props.showConciergeServiceWindow]);

    console.log("******************* ", isMobileView);

    return (

        <div>
            {
                isMobileView ? (
                    <PlannerResponsive
                        showHeader={props.showHeader}
                        showConciergeServiceWindow={props.showConciergeServiceWindow}
                        setShowConciergeServiceWindow={props.setShowConciergeServiceWindow}
                        lookingAt={lookingAt}
                        isSearching={props.isSearching}
                        searchingFor={props.searchingFor}
                        zoomInOn={zoomInOn}
                        _global_map_ref={props._global_map_ref}
                        showAccountDialog={props.showAccountDialog}
                        setShowAccountDialog={props.setShowAccountDialog}
                    />
                ) : (

                    <PlannerContent
                        showHeader={props.showHeader}
                        showConciergeServiceWindow={props.showConciergeServiceWindow}
                        setShowConciergeServiceWindow={props.setShowConciergeServiceWindow}
                        lookingAt={lookingAt}
                        isSearching={props.isSearching}
                        searchingFor={props.searchingFor}
                        zoomInOn={zoomInOn}
                        _global_map_ref={props._global_map_ref}
                        showAccountDialog={props.showAccountDialog}
                        setShowAccountDialog={props.setShowAccountDialog}
                    />
                )
            }

        </div>

    )

}

export default Planner;
